// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading--1todhK","icon":"icon--3bNFDq","small":"small--3JY3Kl","extra-small":"extra-small--2aVnrj","extraSmall":"extra-small--2aVnrj"};